import { render, staticRenderFns } from "./RtcGroupAcceptor.vue?vue&type=template&id=256b3146&scoped=true"
import script from "./RtcGroupAcceptor.vue?vue&type=script&lang=js"
export * from "./RtcGroupAcceptor.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupAcceptor.vue?vue&type=style&index=0&id=256b3146&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b3146",
  null
  
)

export default component.exports